require("./style.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            textLen: 0,
            wordsCount: 0,
            mustUpdate: false
        };
        this.previousValue = '';
    },
    onInput: function (input) {
        if (!input.value || input.value == this.previousValue)
            return;
        if (this.editor)
            switch (typeof input.value) {
            case 'object':
                this.editor.setContents(input.value, 'api');
                break;
            }
        this.previousValue = input.value;
    },
    onMount: function () {
        this.initialize();
    },
    initialize: function () {
        const editorElement = this.getEl('q-editor-area'), readOnly = this.input.readOnly;
        this.editor = new Quill(editorElement, {
            readOnly,
            debug: 'warn',
            placeholder: this.input.placeholder || (!readOnly ? 'Rich text area ...' : ''),
            theme: 'snow',
            modules: { toolbar: !readOnly ? this.getEl('q-editor-toolbar') : false }
        });
        this.input.value && typeof this.input.value == 'object' && this.editor.setContents(this.input.value, 'api');
        this.editor.on('text-change', (delta, oldDelta, source) => {
            if (source != 'user')
                return;
            if (this.input.maxlength)
                this.checkTextLimit();
            if (this.input.maxwords)
                this.checkWordsLimit();
        });
        const $editor = $(editorElement).find('[contenteditable]').on('focus', () => this.emit('focus')).on('blur', () => {
            if (this.reachLimit)
                return;
            let content;
            if (this.input.returnText)
                content = this.editor.getText();
            else if (this.input.returnHTML)
                content = $editor.html();
            else
                content = {
                    ...this.editor.getContents(),
                    author: this.input.author,
                    date: new Date().toDateString(),
                    copyright: 'Multipple 2.0'
                };
            if (!this.input.noReturnWordsCount) {
                const wordsCount = (this.input.returnText ? content : this.editor.getText()).split(/\s+/g).length - 1;
                this.emit('change', content, wordsCount);
            } else
                this.emit('change', content);
        });
    },
    checkTextLimit: function () {
        this.state.textLen = this.editor.getLength() - 1;
        if (this.state.textLen > this.input.maxlength) {
            this.editor.formatText(this.input.maxlength, this.state.textLen, 'color', 'red');
            this.reachLimit = true;
        } else
            this.reachLimit = false;
        this.emit('input-text', this.state.textLen);
    },
    checkWordsLimit: function () {
        const textLen = this.editor.getLength() - 1;
        this.state.wordsCount = this.editor.getText().split(/\s+/g).length - 1;
        if (this.wordLimitPoint && this.state.wordsCount > this.input.maxwords) {
            this.editor.formatText(this.wordLimitPoint, textLen, 'color', 'red');
            this.reachLimit = true;
        } else if (this.state.wordsCount == this.input.maxwords + 1)
            this.wordLimitPoint = textLen - 1;
        else
            this.reachLimit = false;
        this.emit('input-word', this.state.wordsCount);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/QuillEditor/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Quill = require("quill"),
    Quill = module_Quill.default || module_Quill,
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    marko_attrs0 = {
        "class": "position-relative theme-bg"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("bdbaeb"),
    marko_node0 = marko_createElement("li", null, "0", null, 5, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "ql-bold"
        }, null, null, 0)
      .e("button", {
          "class": "ql-italic"
        }, null, null, 0)
      .e("button", {
          "class": "ql-underline"
        }, null, null, 0)
      .e("button", {
          "class": "ql-strike"
        }, null, null, 0)
      .e("select", {
          "class": "ql-color"
        }, null, null, 0),
    marko_attrs1 = {
        "class": "d-inline-block theme-bg-lighten px-75 py-25 rounded font-small-1"
      },
    marko_attrs2 = {
        "class": "q-ul list-inline m-0 d-flex align-items-center"
      },
    marko_node1 = marko_createElement("li", null, "9", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "ql-list",
          value: "bullet"
        }, null, null, 0)
      .e("button", {
          "class": "ql-list",
          value: "ordered"
        }, null, null, 0),
    marko_node2 = marko_createElement("button", {
        "class": "ql-align"
      }, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("button", {
        "class": "ql-align",
        value: "right"
      }, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("button", {
        "class": "ql-align",
        value: "center"
      }, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("button", {
        "class": "ql-align",
        value: "justify"
      }, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("select", {
        "class": "ql-size"
      }, "17", null, 4, 0, {
        i: marko_const_nextId()
      })
      .e("option", {
          value: "small"
        }, null, null, 0)
      .e("option", {
          selected: true
        }, null, null, 0)
      .e("option", {
          value: "large"
        }, null, null, 0)
      .e("option", {
          value: "huge"
        }, null, null, 0),
    marko_node7 = marko_createElement("li", null, "22", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "ql-indent",
          value: "-1"
        }, null, null, 0)
      .e("button", {
          "class": "ql-indent",
          value: "+1"
        }, null, null, 0),
    marko_node8 = marko_createElement("li", null, "25", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "ql-blockquote"
        }, null, null, 0)
      .e("button", {
          "class": "ql-code-block"
        }, null, null, 0),
    marko_node9 = marko_createElement("button", {
        "class": "ql-link"
      }, "29", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("button", {
        "class": "ql-formula"
      }, "30", null, 0, 0, {
        i: marko_const_nextId()
      });

require("quill/dist/quill.snow.css");

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Defaults(out) {
    out.n(marko_node0, component);

    maxParam = input.maxlength || input.maxwords

    currentLen = state.textLen || state.wordsCount

    if (maxParam) {
      out.e("li", null, "6", component, 1)
        .e("span", marko_attrs1, "7", component, 3)
          .t(currentLen, component)
          .t("/")
          .t(maxParam, component);
    }
  }

  function macro_Toolbar(out) {
    if (!input.readOnly) {
      out.be("div", null, "@q-editor-toolbar", component);

      out.be("ul", marko_attrs2, "8", component);

      if (Array.isArray(input.toolbar)) {
        marko_dynamicTag(out, macro_Defaults, null, null, null, null, __component, "32");

        if (input.toolbar.includes("list")) {
          out.n(marko_node1, component);
        }

        if (input.toolbar.includes("align") || input.toolbar.includes("font-size")) {
          out.be("li", null, "12", component);

          if (input.toolbar.includes("align")) {
            out.n(marko_node2, component);

            out.n(marko_node3, component);

            out.n(marko_node4, component);

            out.n(marko_node5, component);
          }

          if (input.toolbar.includes("font-size")) {
            out.n(marko_node6, component);
          }

          out.ee();
        }

        if (input.toolbar.includes("indent")) {
          out.n(marko_node7, component);
        }

        if (input.toolbar.includes("embed-block")) {
          out.n(marko_node8, component);
        }

        if (input.toolbar.includes("link")) {
          out.be("li", null, "28", component);

          out.n(marko_node9, component);

          if (input.toolbar.includes("latex")) {
            out.n(marko_node10, component);
          }

          out.ee();
        }
      } else {
        marko_dynamicTag(out, macro_Defaults, null, null, null, null, __component, "33");
      }

      out.ee();

      out.ee();
    }
  }

  out.be("div", marko_attrs0, "31", component);

  if (input.toolbarTop) {
    marko_dynamicTag(out, macro_Toolbar, null, null, null, null, __component, "34");
  }

  _preserve_tag({
      n: true,
      renderBody: function(out) {
        out.be("div", {
            "class": marko_classValue("font-" + (input.font || "medium-2")),
            style: marko_styleValue(input.style || {
                height: input.height || "180px",
                marginTop: "-1px"
              })
          }, "@q-editor-area", component, null, 1);

        out.h((typeof input.value) == "string" ? input.value : "", component);

        out.ee();
      }
    }, out, __component, "q-editor-area");

  if (!input.toolbarTop) {
    marko_dynamicTag(out, macro_Toolbar, null, null, null, null, __component, "35");
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
